import React from "react";
import { withTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ScreenDone extends React.Component {
  render() {
    const { t, room, settings } = this.props;
    return (
    settings&&settings.accesscontrolDoneWaitToExit&&settings.accesscontrolDoneWaitToExit.value==='True'?
    room.reservation.okToExit?
      <div className="body-right">
        <h1><Trans i18nKey={room.reservation.parking?'roomDressingExitParking':'roomDressingExitStreet'} components={[<FontAwesomeIcon icon="parking" />]} /></h1>
      </div>
      :
      <div className="body-right">
        <h1>{t("Please wait for attendant so that you can exit.")}</h1>
      </div>
    :null
    );
  }
}

export default withTranslation()(ScreenDone);
